export const prescriptionRoutes = {
  'route.prescription.index': '/services/lab-test-home/prescription',
  'route.prescription.checkout': '/services/lab-test-home/prescription/checkout',
  'route.prescription.order': '/services/lab-test-home/prescription/order/[id]',
  'api.prescription.upload-file': 'upload/[sectionType].[sectionTypeDate]/[year]/[month]/[day]/[time]/[type]/file',
};
